import { Navigate } from "react-router-dom";

export default function HowItWorksPage() {
  // Merged into /about#how-it-works
  return <Navigate to="/about#how-it-works" replace />;
}
